import React, { useState, useEffect } from "react";
import axios from "axios";
import progressGif from '../../images/progress.gif';
import { exportToExcel } from "./exportToExcel";
import Sales_Nfsa_Non_Nfsa_Data from './Sales_nfsa_Non_Nfsa_Data';

const Sales_Nfsa_Non_Nfsa = ({ nfsaType, month, year, fetchTrigger }) => {
  const [commodities, setCommodities] = useState([]);
  const [commCodes, setCommCodes] = useState([]);
  const [summaryData, setSummaryData] = useState([]);
  const [monthWiseData, setMonthWiseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [refreshTime, setRefreshTime] = useState("");
  const [selectedMonth, setSelectedMonth] = useState(null);

  const getMonthName = (monthNumber) => {
    const date = new Date();
    date.setMonth(monthNumber - 1);
    return date.toLocaleString("default", { month: "long" });
  };

  useEffect(() => {
    if (!fetchTrigger) return;

    const fetchData = async () => {
      setLoading(true);
      setShowTable(false);
      setError("");
      setCommodities([]);
      setCommCodes([]);
      setSummaryData([]);
      setMonthWiseData([]);

      try {
        const commRes = await axios.get(`${process.env.REACT_APP_URL_SALE}/api/SalesNfsa/commodities`, {
          params: { nfsaType, month, year },
        });
        setCommodities(commRes.data);
        const codes = commRes.data.map(c => c.commId);
        setCommCodes(codes);

        const summaryRes = await axios.post(
          `${process.env.REACT_APP_URL_SALE}/api/SalesNfsa/summary?nfsaType=${nfsaType}&month=${month}&year=${year}`,
          codes
        );
        setSummaryData(summaryRes.data);

        const monthWiseRes = await axios.post(
          `${process.env.REACT_APP_URL_SALE}/api/SalesNfsa/monthWiseSale?nfsaType=${nfsaType}&month=${month}&year=${year}`,
          codes
        );
        setMonthWiseData(monthWiseRes.data);

        setShowTable(true);
        setRefreshTime(new Date().toISOString().replace("T", " ").split(".")[0]);
      } catch (err) {
        console.error(err);
        setError("No Data Found");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [fetchTrigger, nfsaType, month, year]);

  const totals = {};
  commCodes.forEach(code => {
    totals[code] = summaryData.reduce((sum, row) => sum + (row.dynamicFields?.[`comm_code_${code}`] || 0), 0);
  });

  const monthWiseTotals = {};
  commCodes.forEach(code => {
    monthWiseTotals[code] = monthWiseData.reduce((sum, row) => sum + (row.commodityData?.[`comm_code_${code}`] || 0), 0);
  });

  if (error)
    return <p style={{ color: "red", textAlign: "center", fontWeight: "bold" }}>{error}</p>;

  if (loading)
    return <div style={{ textAlign: "center", marginTop: "20px" }}><img src={progressGif} alt="Loading..." width="250" height="15" /></div>;

  if (showTable && commodities.length === 0) {
    const monthName = getMonthName(parseInt(month));
    return <p style={{ color: "red", textAlign: "center", textDecoration: "underline", fontWeight: "bold", fontSize: "16px" }}>No Data Found for {monthName}'{year}</p>;
  }

  return (
    <div>
      {showTable && commodities.length > 0 && (
        <div>
          <table width="60%" align="center">
            <thead>
              <tr className="tableheader">
                <th colSpan={commCodes.length + 1} >
                  {nfsaType === "N" ? "NFSA Sale Abstract (in MTs)" : "Non-NFSA Sale Abstract (in MTs)"}
                </th>
              </tr>
              <tr className="tableheader">
                <th >Allotted <br></br>Month/Year</th>
                {commCodes.map((code) => {
                  const comm = commodities.find(c => c.commId === code);
                  return <th key={code} style={{ padding: "4px" }}>{comm?.commName ?? code}</th>;
                })}
              </tr>
            </thead>
            <tbody>
              {summaryData.length === 0 ? (
                <tr><td colSpan={commCodes.length + 1}>-</td></tr>
              ) : (
                summaryData.map((row, idx) => (
                  <tr key={idx}>
                    <td>{`${getMonthName(parseInt(month))} '${year}`}</td>
                    {commCodes.map((code) => (
                      <td key={code}>
                        {((row.dynamicFields?.[`comm_code_${code}`] ?? 0) / 1000).toFixed(3)}
                      </td>
                    ))}                  </tr>
                ))
              )}
              <tr className="tableheader">
                <td>Total</td>
                {commCodes.map((code) => <td key={code}>{((totals[code] ?? 0) / 1000).toFixed(3)}</td>)}
              </tr>
              <tr>
                <td colSpan={commCodes.length + 1} style={{ textAlign: "right", paddingRight: "10px" }}>
                  <span style={{ color: "red", fontWeight: "bold" }}>Refresh Time : </span>
                  <span style={{ color: "green" }}>{refreshTime}</span>
                </td>
              </tr>
            </tbody>
          </table>

          <div style={{ textAlign: "center", marginBottom: "30px", marginTop: '15px' }}>
            <button
              onClick={() => exportToExcel({ nfsaType, month, year, commodities, commCodes, summaryData, totals, refreshTime })}
              style={{
                padding: "6px 15px", borderRadius: "10px", border: "none",
                backgroundColor: "black", color: "white", cursor: "pointer", marginRight: "10px"
              }}
            >
              Data to Export
            </button>
          </div>
        </div>
      )}

      {monthWiseData.length > 0 && (
        <div style={{ marginTop: "20px" }}>
          <table width="60%" align="center">
            <thead>
              <tr className="tableheader">
                <th colSpan={commCodes.length + 1} >
                  {nfsaType === "N" ? "NFSA Month Wise Sale for " : "Non-NFSA Month Wise Sale for "}
                  <span style={{ color: "orange", fontWeight: "bold" }}>{`${getMonthName(parseInt(month))} '${year}`}</span>
                  {" (in MTs)"}
                </th>
              </tr>
              <tr className="tableheader">
                <th >Distribution <br>
                </br>Month/Year</th>
                {commCodes.map((code) => {
                  const comm = commodities.find(c => c.commId === code);
                  return <th key={code} >{comm?.commName ?? code}</th>;
                })}
              </tr>
            </thead>
            <tbody>
              {monthWiseData.map((row, idx) => (
                <tr key={idx}>
                  <td>
                    <span
                      style={{ color: "black", textDecoration: "underline", cursor: "pointer" }}
                      onClick={() => setSelectedMonth({ month: month, year: year })}
                    >
                      {`${getMonthName(parseInt(month))} '${year}`}
                    </span>
                  </td>
                  {commCodes.map((code) => (
                    <td key={code}>
                      {((row.commodityData?.[`comm_code_${code}`] ?? 0) / 1000).toFixed(3)}
                    </td>
                  ))}                </tr>
              ))}
              <tr className="tableheader">
                <td>Total</td>
                {commCodes.map((code) => <td key={code}>{((monthWiseTotals[code] ?? 0) / 1000).toFixed(3)}</td>)}
              </tr>
              <tr>
                <td colSpan={commCodes.length + 1} style={{ textAlign: "right", paddingRight: "10px" }}>
                  <span style={{ color: "red", fontWeight: "bold" }}>Refresh Time : </span>
                  <span style={{ color: "green" }}>{refreshTime}</span>
                </td>
              </tr>
            </tbody>
          </table>

          <div style={{ textAlign: "center", marginTop: "15px" }}>
            <button
              onClick={() => exportToExcel({ nfsaType, month, year, commodities, commCodes, summaryData: monthWiseData, totals: monthWiseTotals, refreshTime })}
              style={{
                padding: "6px 15px", borderRadius: "10px", border: "none",
                backgroundColor: "black", color: "white", cursor: "pointer", marginRight: "10px"
              }}
            >
              Data to Export
            </button>
          </div>
        </div>
      )}

      {selectedMonth && (
        <div style={{ marginTop: "30px" }}>
          <Sales_Nfsa_Non_Nfsa_Data
            nfsaType={nfsaType}
            distMonth={selectedMonth.month}
            distYear={selectedMonth.year}
            transMonth={selectedMonth.month}
            transYear={selectedMonth.year}
            fetchTrigger={true}
          />
        </div>
      )}
    </div>
  );
};

export default Sales_Nfsa_Non_Nfsa;